import { AccountWithdrawalDetails } from '../../generated-types';

const getFreeWithdrawalStatus = (freeWithdrawals: AccountWithdrawalDetails | undefined) => {
    const hasPerformedWithdrawals =
        typeof freeWithdrawals?.performedWithdrawals === 'number' && freeWithdrawals.performedWithdrawals >= 0;
    const hasTotalNumberOfWithdrawals = !!freeWithdrawals?.totalNumberOfFreeWithdrawals;
    const remainingWithdrawals = Math.max(
        0,
        (freeWithdrawals?.totalNumberOfFreeWithdrawals ?? 0) - (freeWithdrawals?.performedWithdrawals ?? 0),
    );

    return {
        showFreewithdrawal: hasTotalNumberOfWithdrawals,
        hasTotalNumberOfWithdrawals,
        hasPerformedWithdrawals,
        remainingWithdrawals,
    };
};

export default getFreeWithdrawalStatus;
